import React from 'react';
import { Container } from '@chakra-ui/react';

export default function Page({ children, maxW = '6xl', ...props }) {
  return (
    <Container maxW={maxW} px={{ base: 2, md: 6 }} py={{ base: 4, md: 8 }} {...props}>
      {children}
    </Container>
  );
}


